// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/ChatSuite/index.css
// module id = 856
// module chunks = 0